module.exports = __webpack_public_path__ + "static/assets/3f4a908333946ca8df50e998edd762e2.svg";